import { PictureInPicture2Icon } from '@hakimo-ui/hakimo/ui-elements';
import { Button } from '@hakimo-ui/shared/ui-base';
import { useEffect, useRef } from 'react';
import { useSectionState } from './SectionStateContext';
import { DetachableSectionProps } from './util';

export function DetachableSection({
  sectionId,
  title,
  children,
  className = '',
}: DetachableSectionProps) {
  const { sections, toggleSection, updateSectionPosition } = useSectionState();
  const sectionRef = useRef<HTMLDivElement>(null);
  const sectionState = sections[sectionId];
  const isDetached = sectionState?.isDetached || false;

  const handleToggle = () => {
    toggleSection(sectionId);
  };

  useEffect(() => {
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect();
      updateSectionPosition(sectionId, {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX - 450,
      });
    }
  }, [sectionId, updateSectionPosition]);

  if (isDetached) {
    return null;
  }

  return (
    <div
      ref={sectionRef}
      className={`min-w-0 overflow-hidden py-2 ${className}`}
    >
      <div className="relative">
        <div className="flex items-center justify-between font-sans font-semibold">
          <span className="text-onlight-text-1 dark:text-ondark-text-1">
            {title}
          </span>
          <Button
            variant="icon"
            onClick={handleToggle}
            className="!p-1 text-gray-600 hover:text-gray-800 dark:text-gray-500 dark:hover:text-gray-200"
            title="Detach section"
          >
            <PictureInPicture2Icon className="h-4 w-4" />
          </Button>
        </div>
        {children}
      </div>
    </div>
  );
}
